<p>delegate-invitation-sent works!</p>
